<!-- V2 -->
@if (portalReady && isV2) {
  <app-dashboard-v2></app-dashboard-v2>
}

<!-- V1 -->
@if (portalReady && !isV2) {
  <div id="dashboard">
    @if (!onmobileView) {
      <ion-grid style="margin-top: 5em;">
        <ion-row>
          <ion-col size="4"></ion-col>
          <ion-col size="4">
            <img style="display: block; margin: auto" [src]="logoUrl" />
          </ion-col>
          <ion-col size="4"></ion-col>
        </ion-row>
        <br>
          @if (user?.FirstName) {
            <div class="dashboard-welcome-card">
              <div class="dashboard-welcome-text">
                <span class="dashboard-welcome-title" style="margin-bottom: 1em;">
                  {{('Welcome, ' | translate) + (user?.FirstName ?? '') + (user?.LastName ? ' ' + user?.LastName : '') + '!'}}
                </span>
                <!-- <span class="dashboard-welcome-subtitle">
                {{'Where do you want to go today?' | translate}}
              </span> -->
            </div>
          </div>
        }
        <br>
        </ion-grid>
      } @else {
        <ion-grid>
          <ion-row>
            <ion-col size="4"></ion-col>
            <ion-col size="6">
              <img style="margin-top: 5em;" [src]="logoUrl" />
            </ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
        </ion-grid>
        <div>
          <div class="dashboard-welcome-text">
            <span class="dashboard-welcome-title">
              {{('Welcome, ' | translate) + (user?.FirstName ?? '') + (user?.LastName ? ' ' + user?.LastName : '') + '!'}}
            </span>
            <!-- <span class="dashboard-welcome-subtitle">
            {{'Where do you want to go today?' | translate}}
          </span> -->
        </div>
      </div>
    }
    @if (showLoadingReports) {
      <ion-spinner name="circular" class="spinner"></ion-spinner>
    }
  </div>
  <div class="report-list">
    <div id="reports" class="report">
      @for (report of sortedReports; track report) {
        <div>
          @if (report.Pinned || report.UsersFavorite) {
            <div>
              <app-report-card [report]="report" [groupId]="report.Groups[0].GroupID" [onMobileView]="onmobileView" [group]="report.Groups[0]" [portalVersion]="$safeNavigationMigration(configuration?.PortalVersion)"></app-report-card>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
